

import { Group, Nullable, Profile, Tag } from '@brg/api';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedGroup {
    about: string,
    id: string,
    name: string,
    title?: string,
    ownerTeamId: string,
    ownersIDs: string[],
    teachersIDs: string[],
    membersIDs: string[],
    managedTagIds: string[],
    contexts: string[],
    isTranslate?: boolean,
    owners: Profile[],
    members: Profile[],
    teachers: Profile[],
    managedTags:Tag[],
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param team
 */
export function computeGroup(group: Nullable<Partial<Group>>): ComputedGroup {

    return {
        about: group?.about || '',
        id: group?.id || '',
        name: group?.name || '',
        title: group?.name || '',
        isTranslate: true,
        ownersIDs: group?.ownersIDs || [],
        membersIDs: group?.membersIDs || [],
        //@ts-ignore
        teachersIDs: group?.teachersIDs || [],
        managedTagIds: group?.managedTagIds || [],
        contexts: group?.contexts || [],
        owners: group?.owners || [],
        members: group?.members || [],
        //@ts-ignore
        teachers: group?.teachers || [],
        managedTags: group?.managedTags || [],
        //@ts-ignore
        ownerTeamId: group?.ownerTeamId || '',
        //@ts-ignore
        chatLink: group?.chatLink || ''
    };
}


import { Group, Nullable, Profile, Tag } from '@brg/api';

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 */
export interface ComputedGroup {
    about: string,
    id: string,
    name: string,
    title?: string,
    ownerTeamId: string,
    ownersIDs: string[],
    teachersIDs: string[],
    membersIDs: string[],
    managedTagIds: string[],
    contexts: string[],
    isTranslate?: boolean,
    owners: Profile[],
    members: Profile[],
    teachers: Profile[],
    managedTags:Tag[],
}

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param team
 */
export function computeGroup(group: Nullable<Partial<Group>>): ComputedGroup {

    return {
        about: group?.about || '',
        id: group?.id || '',
        name: group?.name || '',
        title: group?.name || '',
        isTranslate: true,
        ownersIDs: group?.ownersIDs || [],
        membersIDs: group?.membersIDs || [],
        //@ts-ignore
        teachersIDs: group?.teachersIDs || [],
        managedTagIds: group?.managedTagIds || [],
        contexts: group?.contexts || [],
        owners: group?.owners || [],
        members: group?.members || [],
        //@ts-ignore
        teachers: group?.teachers || [],
        managedTags: group?.managedTags || [],
        //@ts-ignore
        ownerTeamId: group?.ownerTeamId || '',
        //@ts-ignore
        chatLink: group?.chatLink || ''
    };
}
